import { Link } from "react-router-dom";
import { cadShort, totalStock } from "@/lib/site";
import { BadgeCharacter } from "@/components/brand/BadgeCharacter";

const stickerFor = (p, soldOut) => {
  if (soldOut) return ["Sold out", "black"];
  if (p.sotm_slug || p.badge === "Sus of the Month") return ["SOTM", "sky"];
  if (p.badge) return [p.badge, p.badge.toLowerCase().includes("drop") ? "pink" : "lime"];
  return null;
};

export const ProductCard = ({ product: p, index = 0 }) => {
  const soldOut = totalStock(p) === 0;
  const sticker = stickerFor(p, soldOut);
  return (
    <article className="group" data-testid={`product-card-${p.slug}`}>
      <Link to={`/product/${p.slug}`} className="block" aria-label={`${p.name}, ${cadShort(p.price)}`}>
        <div className="tile relative aspect-square overflow-hidden">
          <img src={p.images[0].src} alt={p.images[0].alt} loading={index < 4 ? "eager" : "lazy"} decoding="async" width="800" height="800" className="h-full w-full object-cover mix-blend-multiply transition-[opacity,transform] duration-700 ease-out group-hover:scale-[1.03] group-hover:opacity-0" />
          {p.images[1] && (
            <img src={p.images[1].src} alt="" aria-hidden="true" loading="lazy" decoding="async" className="photo absolute inset-0 h-full w-full object-cover opacity-0 transition-opacity duration-700 group-hover:opacity-100" />
          )}
          {sticker && <BadgeCharacter label={sticker[0]} tone={sticker[1]} className="absolute left-2.5 top-2.5" testid={`product-badge-${p.slug}`} />}
        </div>
        <div className="mt-4 flex items-start justify-between gap-3">
          <h3 className="font-a text-[15px] leading-snug">{p.name}</h3>
          <div className="flex shrink-0 gap-1.5 pt-1.5">
            {p.colors.map((c) => (
              <span key={c.name} title={c.name} className="h-2.5 w-2.5 rounded-full ring-1 ring-ink/25" style={{ background: c.hex }} />
            ))}
          </div>
        </div>
        <p className="mt-1 text-[13px] text-ink/60" data-testid={`product-card-price-${p.slug}`}>{cadShort(p.price)}</p>
      </Link>
    </article>
  );
};
